import { HOST } from "common-import/constants";
import { observable, autorun, computed } from "mobx";
import { Request, MobXHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import api from "./BiddingCategory.API";
import _ from "lodash";

class BiddingCategoryStore {
  @observable listApproved = [];

  @observable listNotApproved = [];

  @observable currentBidding = {};

  @computed get allListProject() {
    return [...this.listApproved, ...this.listNotApproved];
  }

  setProp = (prop, value) => { this[prop] = value  }
  
  getListApproved = async (page) => {
    let res = await api.adminList({
      // "orderBy": "updatedAt",
	    // "orderType": "DESC",
      "approved": 1,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listApproved = json.data;
    return { status: true };
  }

  getListNotApproved = async (page) => {
    let res = await api.adminList({
      // "orderBy": "updatedAt",
	    // "orderType": "DESC",
      "approved": 0,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  }

  getListNotApprovedUpdate = async (page) => {
    let res = await api.adminList({
      // "orderBy": "updatedAt",
	    // "orderType": "DESC",
      "approved": 3,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  }

  search = async (name, approved) => {
    let res = await api.adminList({
      "name": name,
      "orderBy": "updatedAt",
	    "orderType": "DESC",
	    "approved": approved
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    if(approved == 1) {  
      this.listApproved = json.data;
    } else {
      this.listNotApproved = json.data;
    }
    return { status: true };
  }

  setCurrentBidding = id => {
    let current = this.allListProject.find(val => val.id == id);
    if(current == undefined) return {};
    this.currentBidding = current;
    return current;
  }

  getBiddingDetail = async id => {
    let res = await api.detail(id);
    let json = await res.json();
    return json.data;
  }

  update = async data => {
    const { id } = this.currentProject;
    if(!id) return;
    let res = await api.update(id, data);
    let json = await res.json();
    return json;
  }

  create = async data => {
    let res = await api.create(data);
    let json = await res.json();
    return json;
  }

  approve = async ({id, approved}) => {
    let res = await api.approve({id, approved: approved ? 1 : 0});
    let json = await res.json();
    // if(!json.error) 
    return json;
  }
}


export default new BiddingCategoryStore();


// WEBPACK FOOTER //
// ./src/services/biddingCategory/BiddingCategory.Store.js